<script setup>
defineProps({
  block: { type: Object, required: true },   // { text, author }
})
</script>

<template>
  <figure class="quote-block">
    <blockquote class="text">{{ block.text }}</blockquote>
    <figcaption v-if="block.author" class="author">{{ block.author }}</figcaption>
  </figure>
</template>

<style lang="scss" scoped>
.quote-block {
  margin: 0;
  padding-left: $space-5;
  border-left: 3px solid var(--color-quote-accent);
  display: flex;
  flex-direction: column;
  gap: $space-4;

  .text {
    margin: 0;
    font-size: $font-size-lg;   // one step down from h4, sitewide quote-size review
    line-height: $lh-heading;
    letter-spacing: $ls-heading;
    font-weight: 500;
    color: var(--color-ink);
  }

  .author {
    font-size: $font-size-sm;
    color: var(--color-text-muted);
  }
}
</style>
